import { defaultReducerMapping } from 'app/lib/redux'
import * as actions from 'app/actions/userAssessment'
import * as generalActions from 'app/actions/general'

const initialState = {
  userAssessmentToken: null,
  workflowShare: null,
  initializing: true,
  initializingFailed: false,
  userId: null,
  partnerId: null,
  dietIdId: null,
  dietIdNutritionInfo: null,
  dietIdealId: null,
  dietIdealNutritionInfo: null,
  nutrientDisplayLists: [],
  disclaimer: null
}

let R = {}

R[generalActions.GENERAL_INIT] = (state, action) => {
  return {
    userAssessmentToken: action.urlParams.user_assessment_token
  }
}

R[actions.UA_INIT] = (state, action) => {
  return {
    userAssessmentToken: action.userAssessmentToken
  }
}

R[actions.UA_INIT] = (state, action) => {
  return {
    initializing: true,
    initializingFailed: false
  }
}

R[actions.UA_INIT_FAILED] = (state, action) => {
  return {
    initializing: false,
    initializingFailed: true
  }
}

R[actions.UA_INIT_DONE] = (state, action) => {
  return {
    initializing: false,
    initializingFailed: false,
    userId: action.user.id,
    partnerId: action.partner.id,
    workflowShare: { ...action, type: null, ...action.workflow_share }
  }
}

export default defaultReducerMapping(initialState, R)